module.exports = __webpack_public_path__ + "static/img/works-02.910ac672.png";